export const phoneRegex: RegExp = new RegExp(
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
)

export const accessRegex: RegExp = new RegExp(
  /([0-9]|[A-Z]|[a-z]|-|[\s])/
)
